<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Editar Pessoa'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

              <v-layout row wrap justify-center>
                <v-flex sm10 xs12>
                  <v-text-field
                    label='Nome'
                    v-model="pessoa.nome"
                    required
                    :rules="assuntoSummaryRules255"
                    max-height="400">
                  </v-text-field>
                </v-flex>
              </v-layout>

              <v-layout row wrap justify-center>
                  <v-flex sm10 xs12>
                    <v-checkbox v-model="temNomeSocial" label="Possui nome social?"></v-checkbox>
                  </v-flex>
                  <v-flex sm10 xs12>
                    <v-text-field v-if="temNomeSocial"
                      label='Nome Social'
                      v-model="pessoa.nomeSocial"
                      required
                      :rules="assuntoSummaryRules255"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="editarPessoa()" :disabled="!formularioValido">Salvar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import DataMenu from '@/components/c-date-menu'
  import projetos from '@/utils/projetos'
  import { mapActions } from 'vuex'

  export default {
    props: ['idPessoa'],
    data: () => ({
      formularioValido: false,
      temNomeSocial: false,
      pessoa: {
        nome: '',
        nomeSocial: ''
      },
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      assuntoSummaryRules255: [
        (input) => !!input || 'Este campo é obrigatório',
        (input) => !!input && input.length <= 255 || 'Este campo não pode possuir mais que 255 caracteres'
      ]
    }),
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      cancelar: function () {
        this.$router.push({name: 'ParceriasProjeto', params: {idProjeto: this.idProjeto}})
      },
      editarPessoa: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Editando pessoa.' })

        if (!this.temNomeSocial) {
          this.pessoa.nomeSocial = this.pessoa.nome
        }

        projetos.putPessoa(this.idPessoa, this.pessoa)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
          this.$router.go(-1)
        })
        .catch(error => {
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Editando pessoa.' })
        })
      }
    },
    mounted () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa.' })
      projetos.getPessoa(this.idPessoa)
      .then(response => {
        this.pessoa = response.data
      })
      .catch(error => {
        console.log('Erro ao mandar o request' + error)
      })
      .finally(() => {
        this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando pessoa.' })
      })
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// editar-pessoa.vue?376158b8